import Icon from '../components/Icon.vue'

Icon.register({
  'file-alt': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248C234.8 160 224 149.2 224 136zM288 372C288 378.6 282.6 384 276 384H108C101.4 384 96 378.6 96 372V364C96 357.4 101.4 352 108 352H276C282.6 352 288 357.4 288 364V372zM288 308C288 314.6 282.6 320 276 320H108C101.4 320 96 314.6 96 308V300C96 293.4 101.4 288 108 288H276C282.6 288 288 293.4 288 300V308zM288 236V244C288 250.6 282.6 256 276 256H108C101.4 256 96 250.6 96 244V236C96 229.4 101.4 224 108 224H276C282.6 224 288 229.4 288 236zM384 121.9V128H256V0H262.1C268.5 0 274.6 2.5 279.1 7L377 105C381.5 109.5 384 115.6 384 121.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-alt.js
// module id = LXLs
// module chunks = 144